import { isNil } from 'lodash';

export const validateEmail = (value = ''): boolean | null => {
  // tslint:disable-next-line:max-line-length
  const emailRegexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return emailRegexp.test(value);
};

export const validateRequired = (value?: string): boolean => {
  return !isNil(value);
};

export const validatePassword = (value: string = '') => {
  return !/[\s-]/.test(value);
};

export const validateLength = (value: string = '', minLength: number, maxLength: number) => {
  return value.length >= minLength && value.length <= maxLength;
};

export const validateMatches = (value: any = '', matchFieldName: string, allValues: any) => {
  return value === allValues[matchFieldName];
};



// WEBPACK FOOTER //
// ./src/utils/validators.ts